/**
 * Centralized social media links configuration
 * This file contains all social media platform links used across the website
 */

// Business email (centralized)
export const BUSINESS_EMAIL = 'business@octalchip.com';

// WhatsApp number (using the obfuscated contact utility)
// Note: WhatsApp link is generated dynamically via contactObfuscation.js
export const WHATSAPP_NUMBER = '917574082582'; // Without + prefix for wa.me links
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

// Social media links configuration
// Each entry contains: name, icon (for AppIcon component), url, and iconType ('lucide' or 'react-icons')
export const socialLinks = [
  {
    name: 'Facebook',
    icon: 'Facebook',
    url: 'https://www.facebook.com/people/Octalchip/61586959712930/',
    iconType: 'lucide'
  },
  {
    name: 'Instagram',
    icon: 'Instagram',
    url: 'https://www.instagram.com/octalchiptech/',
    iconType: 'lucide'
  },
  {
    name: 'LinkedIn',
    icon: 'Linkedin',
    url: 'https://www.linkedin.com/company/octalchip',
    iconType: 'lucide'
  },
  {
    name: 'Twitter',
    icon: 'Twitter',
    url: 'https://x.com/octalchip',
    iconType: 'lucide'
  },
  {
    name: 'Discord',
    icon: 'Discord',
    url: 'https://discord.gg/p8Zcgatn9X',
    iconType: 'react-icons'
  },
  {
    name: 'YouTube',
    icon: 'Youtube',
    url: 'https://www.youtube.com/@octalchip',
    iconType: 'lucide'
  },
  {
    name: 'Pinterest',
    icon: 'Pinterest',
    url: 'https://www.pinterest.com/octalchip/',
    iconType: 'react-icons'
  },
  {
    name: 'Bluesky',
    icon: 'Bluesky',
    url: 'https://bsky.app/profile/octalchip.bsky.social',
    iconType: 'react-icons'
  },
  {
    name: 'Reddit',
    icon: 'Reddit',
    url: 'https://www.reddit.com/user/octalchip',
    iconType: 'react-icons'
  },
  {
    name: 'WhatsApp',
    icon: 'WhatsApp',
    url: WHATSAPP_URL,
    iconType: 'react-icons'
  },
  {
    name: 'Telegram',
    icon: 'Telegram',
    url: 'https://t.me/octalchip',
    iconType: 'react-icons'
  },
  {
    name: 'Threads',
    icon: 'Threads',
    url: 'https://www.threads.com/@octalchiptech',
    iconType: 'react-icons'
  },
  {
    name: 'Medium',
    icon: 'Medium',
    url: 'https://medium.com/@octalchip',
    iconType: 'react-icons'
  },
  {
    name: 'Email',
    icon: 'Mail',
    url: `mailto:${BUSINESS_EMAIL}`,
    iconType: 'lucide'
  }
];

// Social links for structured data (sameAs array)
// Used in SEO structured data - includes all platforms
export const socialLinksForStructuredData = [
  'https://www.facebook.com/people/Octalchip/61586959712930/',
  'https://www.instagram.com/octalchiptech/',
  'https://www.linkedin.com/company/octalchip',
  'https://x.com/octalchip',
  'https://discord.gg/p8Zcgatn9X',
  'https://www.youtube.com/@octalchip',
  'https://www.pinterest.com/octalchip/',
  'https://bsky.app/profile/octalchip.bsky.social',
  'https://www.reddit.com/user/octalchip',
  'https://t.me/octalchip',
  'https://www.threads.com/@octalchiptech',
  'https://medium.com/@octalchip',
  'https://github.com/octalchip'
];

// Social links for display (commonly used platforms)
// This excludes Email and WhatsApp from user-facing display
// These are shown to users in the footer, contact page, and other UI components
export const primarySocialLinks = socialLinks.filter(
  social => social.name !== 'Email' && social.name !== 'WhatsApp'
);

// Social links for header (top platforms only)
// Only the most popular/mainstream platforms shown in the header for cleaner design
export const headerSocialLinks = socialLinks.filter(
  social => ['Facebook', 'Instagram', 'LinkedIn', 'Twitter', 'Discord'].includes(social.name)
);

